import { REMOVE } from '../actionTypes'

export const removePost = (postId?: string) => ({
  type: REMOVE.name,
  api: {
    url: 'posts/remove',
    data: { post_id: postId },
  },
})
